const WORKLOG_FIELD_LABELS = Object.freeze({
  // 通用日志与周报
  dailyLogs: "今日工作日志",
  monthlyAchievements: "本周工作",
  nextMonthPlan: "下周计划",
  dailyWorkSummary: "当日工作事实、结果与待办",
  performanceWorkFacts: "量化绩效工作日志",

  // 销售及员工专属量化指标
  studentEnrollments: "招生人数",
  recoveredAmount: "招商/销售回款金额",
  selfChannelRecoveredAmount: "其中：自有渠道回款",
  companyChannelRecoveredAmount: "其中：公司渠道回款",
  storeSalesRecovered: "门店销售回款",
  brandSponsorshipAmount: "品牌赞助金额",
  channelDevelopment: "渠道开发数量",
  monthlyRentRevenue: "月租房收入",
  leaderGroups: "团长开发组数",
  merchantGroups: "商户开发组数",
  supportedRecovery: "支持招商/小屋加盟回款",
  therapyRevenue: "理疗回款/创收",
  voucherConsumption: "赠送理疗券消化金额",
  therapyHours: "理疗服务时长",
  memberOrganizations: "成交会员单位",
  skuInboundGroups: "SKU入库组数",
  gmvAmount: "GMV",
  nonContestGmvAmount: "其中：非大赛期间GMV",
  brokerCount: "拓店开发 - 黄牛个数",
  selfBroughtCustomerOrders: "自带客户单数",
  gmvRevenue: "GMV收入",

  // 品牌、心理咨询和人事量化指标
  videosProduced: "视频制作数量",
  totalViews: "视频阅读量",
  netFollowerGrowth: "全月粉丝增长",
  validForms: "有效成交表单",
  formRevenue: "表单成交金额",
  consultingHours: "咨询服务时长",
  consultingRevenue: "咨询服务创收",
  retainedEmployees: "月度有效留存人数",

  // 财务
  fundAndSettlement: "报销、现金银行收支、往来款及备用金核对",
  accountingAndTax: "凭证报表、税务工商、发票及社保公积金",
  budgetAndReporting: "项目销售收款日报、税金预估与经营支持",
  riskAndCollaboration: "账实核对、固定资产台账及异常闭环",

  // 前台
  receptionAndBusinessSupport: "前台接待与商务接待",
  environmentAndMeetingService: "一二楼卫生、会议室茶水与绿植维护",
  mealAndTablewareSupport: "午晚餐采购与餐前餐具摆放",
  otherAssignedSupport: "送木木及其他临时支持事项",

  // 销售、品牌非量化指标
  salesProcess: "销售过程质量",
  channelQuality: "渠道开发质量",
  meetingReception: "会务接待",
  contentPlanning: "内容策划与传播",
  channelOperation: "渠道运营与投放",
  brandInteraction: "品牌互动与舆情",

  // 产品、研发与设计
  requirementSolutionDelivery: "需求分析、技术方案与按期交付",
  fullStackImplementation: "前后端功能开发、接口联调与代码质量",
  testingReleaseQuality: "测试、缺陷修复、发布与验收质量",
  stabilityPerformanceSecurity: "部署运维、稳定性、性能、数据与安全",
  collaborationDocumentation: "跨部门协同、技术文档与知识沉淀",
  marketAndUserResearch: "市场调研、用户需求与产品规划",
  projectFullCycle: "项目全流程进度、质量与风险管理",
  testingAndAcceptance: "产品测试、功能校验与上线验收",
  aiInnovation: "AI与大模型场景融合及创新落地",
  crossDepartmentDelivery: "跨部门协同、上线与常态化运营",
  uiInterfaceDesign: "Web、H5、小程序及后台UI界面设计",
  interactionVisualSolution: "需求讨论、交互与视觉方案",
  prototypeToHighFidelity: "产品原型到高保真设计稿转化",
  implementationAcceptance: "前端还原配合与视觉验收",
  designSystem: "UI规范、组件、色彩与字体体系",
  userExperienceOptimization: "基于数据反馈的用户体验优化",
  graphicViMaterialDesign: "海报、VI及宣传物料设计",

  // 人力资源
  recruitmentProcess: "招聘过程与到岗转化",
  retentionManagement: "员工留存跟进与风险处置",
  personnelCompliance: "人事手续、档案与薪酬协同"
});

/** 所有日志详情统一通过这里把后端字段 code 转成中文。 */
export function worklogFieldLabel(code) {
  return WORKLOG_FIELD_LABELS[code] || code;
}

export default WORKLOG_FIELD_LABELS;



// WEBPACK FOOTER //
// ./src/utils/worklogFields.js